import API from "./api"

export default function useAddAccountAttachment() {
  const path = "/attachments"

  function update(id) {
    return async (data) => {
      await API.put(`${path}/${id}`, data)
    }
  }

  function destroy(id) {
    return async () => {
      await API.delete(`${path}/${id}`)
    }
  }

  return async function (files, params) {
    const attachments = await API.postFileUpload(path, files, params)

    if (Array.isArray(attachments)) {
      for (const attachment of attachments) {
        attachment.update = update(attachment.id)
        attachment.destroy = destroy(attachment.id)
      }
    }

    return attachments
  }
}
